import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";

@Component({
    selector: "cerrix-button",
    imports: [],
    templateUrl: "./cerrix-button.component.html",
    styleUrl: "./cerrix-button.component.scss",
    encapsulation: ViewEncapsulation.None,
})
export class CerrixButtonComponent implements OnInit {
    @Input() buttonType: "primary" | "secondary" = "primary";
    @Input() primaryColor: "blue" | "green" | "red" | "yellow" = "blue";
    @Input() secondaryColor: "outlined" | "outlined-gray" | "filled" | "filled-blue" = "outlined";
    @Input() buttonSize: "big" | "medium" | "small" = "medium";
    @Input() public waitingOnResult: boolean = false;
    @Input() public showResultText: boolean = false;
    @Input() disabled: boolean = false;

    public buttonClass: string = "";

    ngOnInit(): void {
        // Prefixing the classes with 'cerrix-btn-' to avoid conflicts with other styling rules
        // and create a class for the button
        this.buttonClass = `cerrix-btn-${this.buttonType} cerrix-btn-${this.buttonSize} ${
            this.buttonType === "primary"
                ? `cerrix-btn-${this.primaryColor}`
                : `cerrix-btn-${this.secondaryColor}`
        }`;
    }
}
